/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Create_New_PromptInputs */

const en_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new Share to begin.`)
};

const fr_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un nouveau partage pour commencer.`)
};

const de_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie zunächst eine neue Freigabe.`)
};

const it_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per iniziare, crea una nuova condivisione.`)
};

const ru_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для начала создайте новую общую папку.`)
};

const es_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un nuevo recurso compartido para comenzar.`)
};

const zh_cn2_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首先，创建一个新的共享文件夹。`)
};

const ja_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するには新しい共有を作成してください。`)
};

const hi_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआत करने के लिए एक नया शेयर बनाएं।`)
};

const pt_pt2_team_share_create_new_prompt = /** @type {(inputs: Team_Share_Create_New_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um novo compartilhamento para começar.`)
};

/**
* | output |
* | --- |
* | "Create a new Share to begin." |
*
* @param {Team_Share_Create_New_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_create_new_prompt = /** @type {((inputs?: Team_Share_Create_New_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Create_New_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_create_new_prompt(inputs)
	if (locale === "de") return de_team_share_create_new_prompt(inputs)
	if (locale === "it") return it_team_share_create_new_prompt(inputs)
	if (locale === "ru") return ru_team_share_create_new_prompt(inputs)
	if (locale === "es") return es_team_share_create_new_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_create_new_prompt(inputs)
	if (locale === "ja") return ja_team_share_create_new_prompt(inputs)
	if (locale === "hi") return hi_team_share_create_new_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_create_new_prompt(inputs)
	return en_team_share_create_new_prompt(inputs)
});